<template>
    <v-container fluid class="transition-view">
        <v-card v-if="editDevice">
            <v-card-title primary-title>
                <div>
                    <div class="headline">Sensor bearbeiten</div>
                    <span class="grey--text">Id: {{editDevice.device}}</span>
                </div>
            </v-card-title>
            <v-progress-linear v-show="loading" class="ma-0" height="5" color="secondary"
                               :indeterminate="true"></v-progress-linear>

            <v-form @submit.prevent="saveEdit" v-model="editFromValid"
                    lazy-validation>
                <v-card-text>
                    <v-layout wrap align-center>
                        <v-flex xs12>
                            <v-text-field :disabled="loading" :rules="labelRules" v-model="editDevice.label"
                                          label="Bezeichnung" required></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                            <v-text-field :disabled="loading" :rules="phoneRules" v-model="editDevice.phone"
                                          label="Telefon (inkl. Länder  vorwahl)" required></v-text-field>
                        </v-flex>
                        <!--
                        <v-flex xs12>
                            <h4>WLAN Konfiguration</h4>
                        </v-flex>
                        <v-flex xs12>
                            <v-layout v-for="(wpac, index) in editDevice.wpa" :key="index" wrap align-center>
                                <v-flex xs5 class="pr-5">
                                    <v-text-field :disabled="loading" v-model="wpac.ssid" autocomplete="false"
                                                  label="SSID" required :rules="ssidRules"></v-text-field>
                                </v-flex>
                                <v-flex xs5>
                                    <v-text-field append-icon="visibility"
                                                  @click:append="toggleWPAPass(index)"
                                                  name="newpassword" label="Passwort"
                                                  autocomplete="false" required :rules="passphraseRules"
                                                  :type="wpaPasswordVisibility[index]" v-model="wpac.psk"
                                    ></v-text-field>
                                </v-flex>
                                <v-spacer></v-spacer>
                                <v-flex shrink>
                                    <v-btn class="ml-0" icon @click="removeWPA(wpac)">
                                        <v-icon>delete</v-icon>
                                    </v-btn>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex>
                            <v-btn small @click="appendWpaConfig" class="ml-0" :disabled="editDevice.wpa.length > 4">
                                Access Point hinzufügen
                            </v-btn>
                        </v-flex>
                        -->
                    </v-layout>
                </v-card-text>
                <v-card-actions>
                    <v-layout wrap>
                        <v-btn :disabled="!editFromValid || loading" @click="confirmCloneDialog = true"
                               color="orange darken-1"
                               flat>Neue Umgebung
                        </v-btn>
                        <v-spacer></v-spacer>
                        <div>
                            <v-btn color="blue darken-1" flat @click="cancelEdit">Abbrechen</v-btn>
                            <v-btn :disabled="!editFromValid || loading" type="submit" color="blue darken-1" flat>
                                Speichern
                            </v-btn>
                        </div>
                    </v-layout>
                </v-card-actions>
            </v-form>
        </v-card>
        <v-dialog v-model="confirmCloneDialog" max-width="400px" persistent>
            <v-card>
                <v-card-title class="headline">Neue Umgebung erstellen?</v-card-title>
                <v-card-text>
                    Wenn eine neue Umgebung für den Sensor erstellt wird, werden alle neue Sensordaten dieser
                    Umgebung
                    zugeordnet.
                    Die bisherigen Daten sind somit nicht mehr sichtbar.
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" flat="flat" @click="confirmCloneDialog = false">
                        Abbrechen
                    </v-btn>

                    <v-btn color="green darken-1" flat="flat" @click="saveClone">
                        Neue Umgebung erstellen
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

const {mapGetters, mapActions} = createNamespacedHelpers('sensor')

export default {
  name: 'EditSensor',
  props: ['id'],
  data () {
    return {
      passwordType: 'password',
      wpaPasswordVisibility: [],
      editDevice: null,
      confirmCloneDialog: false,
      updater: null,
      editFromValid: false,
      loading: false,
      labelRules: [
        v => !!v || 'Bezeichnung ist erforderlich'
      ],
      phoneRules: [
        v => !!v || 'Telefon ist erforderlich',
        v => !(v.startsWith('+')) || 'Fur die Vorwahl "00" statt "+" verwenden',
        v => /^\d+$/.test(v) || 'Nur Zahlen verwenden'
      ],
      ssidRules: [
        v => !!v || 'SSID ist erforderlich'
      ],
      passphraseRules: [
        v => !!v || 'Passwort ist erforderlich'
      ],
    }
  },
  computed: {
    ...mapGetters(['getSensorById'])
  },
  methods: {
    async saveEdit () {
      this.loading = true
      await this.updateEnv(this.editDevice)
      this.$store.commit('core/snackBarShow', {text: 'Die Einstellungen wurden gespeichert.'})
      this.cancelEdit()
    },
    async saveClone () {
      this.confirmCloneDialog = false
      this.loading = true
      this.editDevice.clone = true
      await this.updateEnv(this.editDevice)
      this.cancelEdit()
    },
    cancelEdit () {
      this.editDevice = null
      this.$router.push({name: 'dashboard'})
    },
    appendWpaConfig () {
      this.editDevice.wpa = [...this.editDevice.wpa, {'ssid': '', 'psk': ''}]
      this.wpaPasswordVisibility.push('password')
    },
    toggleWPAPass (index) {
      this.$set(this.wpaPasswordVisibility, index, this.wpaPasswordVisibility[index] === 'text' ? 'password' : 'text')
    },
    removeWPA (wpaConfig) {
      let index = this.editDevice.wpa.indexOf(wpaConfig)
      if (index > -1) {
        this.editDevice.wpa.splice(index, 1)
      }
    },
    ...mapActions(['getSensors', 'updateEnv'])
  },
  async created () {
    let sensor = this.getSensorById(this.id)
    if (!sensor) {
      await this.getSensors()
      sensor = this.getSensorById(this.id)
    }
    this.editDevice = {
      device: sensor.device,
      label: sensor.environment.label,
      phone: sensor.environment.phone,
      wpa: [...sensor.environment.wpa],
      clone: false
    }
    let w = 0
    while (w < sensor.environment.wpa.length) {
      this.wpaPasswordVisibility[w] = 'password'
      w++
    }
    this.$store.commit('core/setViewLoading', false)
  }
}
</script>

<style lang="scss">
</style>
